import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SwitchBox } from '../../../molecules/switch-box';
import { SliderBox } from '../../../molecules/slider-box';
import { useSelector } from '../../../store/utils';

export const SettingsCircuitBreaker = () => {
  const largeInstallation = useSelector((s) => s.variables.LARGE_INSTALLATION);

  return (
    <>
      <SwitchBox
        title={
          <FormattedMessage
            id="settings.utility.numberofphase"
            defaultMessage="Tří-fázová instalace"
          />
        }
        switchVariableId="PHASE_3_FVE"
        fullWidth
      />
      <SliderBox
        title={
          <FormattedMessage
            id="settings.utility.settings.ampers"
            defaultMessage="Velikost jističe"
          />
        }
        variableId="EM_MAX_CURRENT"
        opts={{ style: 'unit', unit: 'ampere', maximumFractionDigits: 0 }}
        min={0}
        max={largeInstallation ? 2000 : 100}
        step={largeInstallation ? 5 : 1}
      />
    </>
  );
};
